var exports = {
  "kL": "x804f0401--fa8ed0--container",
  "y0": "x804f0401--fa8ed0--container--popup",
  "HU": "x804f0401--fa8ed0--aside",
  "iW": "x804f0401--fa8ed0--main",
  "cy": "x804f0401--fa8ed0--author",
  "n2": "x804f0401--fa8ed0--main-heading",
};

module.exports = exports;
